import uzUZ from 'antd/locale/uz_UZ';
import ruRU from 'antd/locale/ru_RU';
import enUS from 'antd/locale/en_US';
import type { LanguageCode } from '../types/i18n';
import type { Locale } from 'antd/es/locale';

const localeMap: Record<LanguageCode, Locale> = {
  uz: uzUZ,
  ru: ruRU,
  en: enUS,
};

export function getAntdLocale(lang: LanguageCode): Locale {
  return localeMap[lang] ?? enUS;
}
